<template>
  <EmptyState>
    <template #custom>
      <font-awesome-icon
        icon="fa-regular fa-triangle-exclamation"
        class="empty-icon tw-text-[50px] tw-text-warning-icon"
      />
      <h1>Something went wrong on our end.</h1>
      <h3 class="empty-message">Don't worry, it's not you</h3>
    </template>
  </EmptyState>
</template>

<script>
import EmptyState from "@/components/display/empty-state/EmptyState";
export default {
  name: "ErrorState",
  components: { EmptyState },
};
</script>
<style lang="scss" scoped>
.empty-icon {
  margin-bottom: 16px;
}
.empty-message {
  margin-top: 16px;
  font-weight: 400;
}
</style>
